import { ActivatedRoute } from '@angular/router';
import { Resolvers } from '../../types/Resolvers';

// ===== UTILIDADES GENERALES =====

/**
 * Función utilitaria para extraer datos de un resolver
 * @param resolver Nombre del resolver
 * @param activateRoute Ruta activa de Angular
 * @returns Datos extraídos del resolver
 */
export const getDataFromResolver = <T>(
  resolver: Resolvers,
  activateRoute: ActivatedRoute
) => {
  const value = activateRoute.snapshot.data[resolver] as T;

  return value;
};
